import AsyncStorage from "@react-native-async-storage/async-storage";
import * as actionTypes from "./actionTypes";

export const actions = {
  // new auth actions
  restoreToken: ({ token, newlyCreatedUser, isUserLoggedInFirst }) => ({
    type: actionTypes.AUTH_ACTIONS.RESTORE_TOKEN,
    payload: {
      token,
      newlyCreatedUser,
      isUserLoggedInFirst,
    },
  }),
  signOut: () => ({
    type: actionTypes.AUTH_ACTIONS.SIGN_OUT,
  }),
  restoreUserToken: (payload) => ({
    type: actionTypes.AUTH_ACTIONS.RESTORE_USER_TOKEN,
    payload,
  }),
  signOutUser: () => ({
    type: actionTypes.AUTH_ACTIONS.SIGN_OUT_USER,
  }),
  setNewUserRequest: () => ({
    type: actionTypes.AUTH_ACTIONS.SET_NEW_USER_REQUEST,
  }),
  setNewUser: ({
    newlyCreatedUser,
    navigateWhatsappScreenForNewUser,
    showWelcomeTLtoTlToNew,
    signupSessionVideo,
    startSession,
    times_onboarding_video_shown,
    signup_add_req,
  }) => ({
    type: actionTypes.AUTH_ACTIONS.SET_NEW_USER,
    payload: {
      newlyCreatedUser,
      navigateWhatsappScreenForNewUser,
      showWelcomeTLtoTlToNew,
      signupSessionVideo,
      startSession,
      times_onboarding_video_shown,
      signup_add_req,
    },
  }),
  removeNewUserRequest: () => ({
    type: actionTypes.AUTH_ACTIONS.REMOVE_NEW_USER_REQUEST,
  }),
  removeNewUser: () => ({
    type: actionTypes.AUTH_ACTIONS.REMOVE_NEW_USER,
  }),

  setUserNumberForLogin: (payload) => ({
    type: actionTypes.SET_USER_NUMBER_FOR_LOGIN,
    payload,
  }),
  getUserDetailsByTokenRequest: (payload) => ({
    type: actionTypes.GET_USER_DETAILS_BY_TOKEN_REQUEST,
    payload,
  }),
  setTeamLeaderDetails: (payload) => ({
    type: actionTypes.GET_USER_DETAILS_BY_TOKEN_SUCCESS,
    payload,
  }),
  setUpdatedBasicInfo: (payload) => ({
    type: actionTypes.UPDATE_BASIC_INFO_IN_USER,
    payload,
  }),
  setBranchIoParams: (params = {}) => ({
    type: actionTypes.SET_BRANCH_IO_PARAMS,
    params,
  }),
  resetBranchIoParams: () => ({
    type: actionTypes.RESET_BRANCH_IO_PARAMS,
  }),
  setFetchMeCompleted: () => ({
    type: actionTypes.SET_FETCH_ME_COMPLETED,
  }),
  resetFetchMeCompleted: () => ({
    type: actionTypes.RESET_FETCH_ME_COMPLETED,
  }),
  showSuspensionModal: (payload = false) => ({
    type: actionTypes.SHOW_SUSPENSION_MODAL,
    payload,
  }),
  showVacationModal: (payload = false) => ({
    type: actionTypes.SHOW_VACATION_MODAL,
    payload,
  }),
  updateVacationModalData: (payload = {}) => ({
    type: actionTypes.VACATION_MODAL_DATA,
    payload,
  }),
  setLanguage: (payload) => ({
    type: actionTypes.SET_LANGUAGE,
    payload,
  }),
  updateLiveLocation: (payload) => ({
    type: actionTypes.LIVE_LOCATION,
    payload,
  }),
  deactivateAccount: () => ({
    type: actionTypes.DEACTIVATE_ACCOUNT,
  }),
  updateContact: (payload) => ({
    type: actionTypes.CONTACT_UPDATE,
    payload,
  }),
  disableEarlyJourneyWhenComplete: () => ({
    type: actionTypes.DISABLE_EARLY_JOURNEY_WHEN_COMPLETE,
  }),
  disableInitialJourneyWhenComplete: () => ({
    type: actionTypes.DISABLE_INITIAL_JOURNEY_WHEN_COMPLETE,
  }),
  updateShowCMSOne: () => ({
    type: actionTypes.UPDATE_SHOWCMS1,
  }),
  updateShowAddressScreen: (payload) => ({
    type: actionTypes.UPDATE_SHOW_ADDRESS_SCREEN,
    payload,
  }),
  setLoggedInModalData: (payload = false) => ({
    type: actionTypes.SET_LOGGEDIN_MODAL_DATA,
    payload,
  }),
  setLoggedInOptions: (payload) => ({
    type: actionTypes.SET_LOGGED_IN_OPTIONS,
    payload,
  }),
  signIn: (payload) => ({
    type: actionTypes.AUTH_ACTIONS.SIGN_IN,
    payload,
  }),
  setLoginParams: (payload) => ({
    type: actionTypes.SET_LOGIN_RELATED_PARAMS,
    payload,
  }),
};

const user = {
  atl_id: "",
  tl_id: "",
  expires_at: "",
  logged_out_at: "",
  id: "",
  url: "",
  name: "",
  address: "",
  phone_number: "",
  created_at: "",
  user_id: "",
  leader_id: "",
  address_name: "",
  address1: "",
  address2: "",
  landmark: "",
  pincode: "",
  city: "",
  state: "",
  address_phone: "",
  address_user_id: "",
  leader_state: "",
  bank_details: {
    ifsc_code: "",
    account_number: "",
    bank_name: "",
    account_holder_name: "",
  },
  language: "hi",
  orderMetricsEnabled: false,
  cp_db_id: "",
  db_name: "",
  db_phone_number: "",
  show_product_commission: true,
};
const initialState = {
  user,
  isLoading: true,
  userToken: null,
  isSignout: false,

  // new user data
  newlyCreatedUser: null,
  navigateWhatsappScreenForNewUser: null,
  showWelcomeTLtoTlToNew: null,
  signupSessionVideo: null,
  startSession: null,
  isUserLoggedInFirst: null,
  // times_onboarding_video_shown: null,

  phone_number: null,
  bankAccount: null,
  newRegistrationDetail: {},
  tracking_info: {
    installParams: {},
  },
  fetchMeCompleted: false,
  isNewlyCretedUser: null,
  loggedInFirstTime: null,
  showSuspensionModal: false,
  showVacationModal: false,
  canContact: null,
  vacationDetails: {},
  loggedInModal: {
    visible: false,
  },
  loggedInDevicesSummary: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_ACTIONS.RESTORE_USER_TOKEN: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case actionTypes.AUTH_ACTIONS.RESTORE_TOKEN: {
      return {
        ...state,
        userToken: action.payload.token,
        newlyCreatedUser: action.payload.newlyCreatedUser,
        isUserLoggedInFirst: action.payload.isUserLoggedInFirst,
        isLoading: false,
      };
    }
    case actionTypes.VACATION_MODAL_DATA: {
      return {
        ...state,
        showVacationModal: action.payload?.showVacationModal,
        vacationDetails: action.payload?.vacationDetails,
      };
    }
    case actionTypes.AUTH_ACTIONS.SET_NEW_USER: {
      return {
        ...state,
        newlyCreatedUser: action.payload.newlyCreatedUser,
        navigateWhatsappScreenForNewUser:
          action.payload.navigateWhatsappScreenForNewUser,
        showWelcomeTLtoTlToNew: action.payload.showWelcomeTLtoTlToNew,
        signupSessionVideo: action.payload.signupSessionVideo,
        startSession: action.payload.startSession,
        times_onboarding_video_shown:
          action.payload.times_onboarding_video_shown,
      };
    }
    case actionTypes.AUTH_ACTIONS.REMOVE_NEW_USER: {
      return {
        ...state,
        newlyCreatedUser: null,
        isUserLoggedInFirst: null,
      };
    }
    case actionTypes.AUTH_ACTIONS.SIGN_OUT: {
      return {
        ...state,
        userToken: null,
      };
    }
    case actionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        user: action.payload,
        isLoggedIn: true,
      };
    }
    case actionTypes.SET_USER_NUMBER_FOR_LOGIN: {
      // SET a global identifier here for first time login
      (async () => {
        await AsyncStorage.setItem("firstTimeLoggedIn", "true");
      })();

      return {
        ...state,
        phone_number: action.payload || null,
      };
    }
    case actionTypes.GET_USER_DETAILS_BY_TOKEN_SUCCESS: {
      return {
        ...state,
        user: action.payload,
      };
    }
    case actionTypes.UPDATE_BASIC_INFO_IN_USER: {
      return {
        ...state,
        user: { ...state.user, ...action.payload },
      };
    }
    case actionTypes.SET_BRANCH_IO_PARAMS: {
      let res;
      if (action.params && action.params.installParams) {
        res = {
          ...state.tracking_info,
          installParams: action.params.installParams,
        };
      } else {
        res = {
          installParams: state.tracking_info.installParams,
          ...action.params,
        };
      }
      (async () => {
        await AsyncStorage.setItem("TRACKING_INFO", JSON.stringify(res));
      })();

      return {
        ...state,
        tracking_info: res,
      };

      // return {
      //   ...state,
      //   tracking_info: action.params
      // };
    }

    case actionTypes.RESET_AUTH_STATE: {
      return {
        ...initialState,
        isLoading: state.isLoading,
      };
    }

    case actionTypes.SET_FETCH_ME_COMPLETED: {
      return {
        ...state,
        fetchMeCompleted: true,
      };
    }

    case actionTypes.RESET_FETCH_ME_COMPLETED: {
      return {
        ...state,
        fetchMeCompleted: false,
      };
    }

    case actionTypes.SHOW_SUSPENSION_MODAL: {
      return {
        ...state,
        showSuspensionModal: action.payload,
      };
    }

    case actionTypes.SHOW_VACATION_MODAL: {
      return {
        ...state,
        showVacationModal: action.payload,
      };
    }

    case actionTypes.SET_LANGUAGE: {
      return {
        ...state,
        user: { ...state.user, language: action.payload },
      };
    }

    case actionTypes.LIVE_LOCATION: {
      return {
        ...state,
        coords: action.payload,
      };
    }

    case actionTypes.DEACTIVATE_ACCOUNT: {
      return {
        ...state,
        user: { ...state.user, leader_state: "LEADER_DEACTIVATED" },
      };
    }

    case actionTypes.CONTACT_UPDATE: {
      return {
        ...state,
        canContact: action.payload.data,
      };
    }

    case actionTypes.SET_CLDROPDOWNOPTIONS: {
      return {
        ...state,
        clDropDownOptions: action.payload,
      };
    }

    case actionTypes.DISABLE_EARLY_JOURNEY_WHEN_COMPLETE: {
      return {
        ...state,
        user: {
          ...state.user,
          earlyJourney: {
            ...state.user.earlyJourney,
            enableEJ: false,
          },
        },
      };
    }

    case actionTypes.UPDATE_SHOWCMS1: {
      return {
        ...state,
        user: {
          ...state.user,
          earlyJourney: {
            ...state.user.earlyJourney,
            showCms1: false,
            showAddressScreen: true,
          },
        },
      };
    }

    case actionTypes.UPDATE_SHOW_ADDRESS_SCREEN: {
      return {
        ...state,
        user: {
          ...state.user,
          earlyJourney: {
            ...state.user.earlyJourney,
            showAddressScreen: false,
            showCms2: true,
          },
          address1: action.payload?.address1,
          address2: action.payload?.address2,
        },
      };
    }
    case actionTypes.DISABLE_INITIAL_JOURNEY_WHEN_COMPLETE: {
      return {
        ...state,
        user: {
          ...state.user,
          earlyJourney: {
            ...state.user.earlyJourney,
            enableIJ: false,
          },
        },
      };
    }

    case actionTypes.SET_LOGGEDIN_MODAL_DATA: {
      return {
        ...state,
        loggedInModal: action.payload,
      };
    }

    case actionTypes.SET_LOGGED_IN_OPTIONS: {
      return {
        ...state,
        loggedInDevicesSummary: action.payload,
      };
    }

    case actionTypes.SET_LOGIN_RELATED_PARAMS: {
      const { meParams, setupParams } = action.payload;
      const {
        userToken,
        discardedAt,
        rejectedAt,
        leaderState,
        userName,
        alreadyCx,
        alreadyCxWoOrder,
      } = meParams;
      const { userPincode, deviceGeog, isServiceable, lat, lng } = setupParams;
      return {
        ...state,
        userToken,
        user: {
          ...state.user,
          already_a_cx: alreadyCx,
          already_a_cx_wo_order: alreadyCxWoOrder,
          discarded_at: discardedAt,
          rejected_at: rejectedAt,
          device_location_geog: deviceGeog,
          lat,
          lng,
          leader_state: leaderState,
          name: userName,
          pincode: userPincode,
          is_serviceable: isServiceable,
        },
      };
    }
  }

  return state;
};

reducer.initialState = initialState;

export default reducer;
